import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { useRouter } from "next/router";
import { printHouseProfile } from "@/store/print-house-profile";

/** Browser path, without query or hash. `router.pathname` is the file pattern. */
const pathOf = (asPath: string) =>
  (asPath || "").split("?")[0].split("#")[0].replace(/\/$/, "") || "/";

const SUBSCRIPTIONS_PATH = "/settings/subscriptions";

const useTrialRedirect = () => {
  const router = useRouter();
  const printHouseProfileState = useRecoilValue(printHouseProfile);
  const currentPath = pathOf(router.asPath);
  const isOnSubscriptionsPage = currentPath === SUBSCRIPTIONS_PATH;

  useEffect(() => {
    // Subscriptions lives at /settings/[settingsRoute], so pathname is never
    // "/settings/subscriptions". Comparing pathname re-pushed the same URL on
    // every pass; each completion folded the side menu shut.
    if (printHouseProfileState?.trialFinished && !isOnSubscriptionsPage) {
      router.push(SUBSCRIPTIONS_PATH);
    }
  }, [printHouseProfileState?.trialFinished, isOnSubscriptionsPage, router]);

  return {
    isTrialFinished: printHouseProfileState?.trialFinished,
    isOnSubscriptionsPage,
  };
};

export { useTrialRedirect };
